// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
import quoteApi from '~/apis/quote';
// Others
import {
  CHANGE_STATUS_QUOTE,
  CLONE_QUOTE,
  CONVERT_QUOTE_TO_ORDER,
  CREATE_QUOTE,
  DELETE_QUOTE,
  GET_DETAIL_QUOTE,
  GET_LIST_QUOTE,
  SEND_MAIL_QUOTE,
  UPDATE_QUOTE,
} from '~/utils/constants/actionType';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  IBodyChangeStatusQuote,
  ICloneQuote,
  IQueryParamQuote,
  IQueryParamQuoteDetail,
} from '~/utils/interface/quotes';

export const getListQuote = createAsyncThunk(GET_LIST_QUOTE, async (params: IQueryParamQuote, { rejectWithValue }) => {
  try {
    const resp = await quoteApi.getListQuote(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailQuote = createAsyncThunk(
  GET_DETAIL_QUOTE,
  async (params: IQueryParamQuoteDetail, { rejectWithValue }) => {
    try {
      const resp = await quoteApi.getDetailQuote(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createQuote = createAsyncThunk(CREATE_QUOTE, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await quoteApi.createQuote(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateQuote = createAsyncThunk(
  UPDATE_QUOTE,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await quoteApi.updateQuote(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteQuote = createAsyncThunk(DELETE_QUOTE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await quoteApi.deleteQuote(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const convertQuoteToOrder = createAsyncThunk(
  CONVERT_QUOTE_TO_ORDER,
  async (quoteId: string, { rejectWithValue }) => {
    try {
      const resp = await quoteApi.convertQuoteToOrder(quoteId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeStatusQuote = createAsyncThunk(
  CHANGE_STATUS_QUOTE,
  async (body: IBodyChangeStatusQuote, { rejectWithValue }) => {
    try {
      const resp = await quoteApi.changeStatusQuote(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const cloneQuote = createAsyncThunk(CLONE_QUOTE, async (body: ICloneQuote, { rejectWithValue }) => {
  try {
    const resp = await quoteApi.cloneQuote(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const sendMailQuote = createAsyncThunk(
  SEND_MAIL_QUOTE,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await quoteApi.sendMailQuote(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
